import { useEffect, useState } from 'react';
import { utils } from '@atlaskit/util-service-support';
import { parseSiteARI } from '../../utils/ari';
import { Products } from '../product-context';
var ProductsFromARI = /*#__PURE__*/function (ProductsFromARI) {
  ProductsFromARI["JIRA"] = "jira";
  ProductsFromARI["CONFLUENCE"] = "confluence";
  ProductsFromARI["TOWNSQUARE"] = "townsquare";
  return ProductsFromARI;
}(ProductsFromARI || {}); // this is same as Atlas
const CONFIG_API_URL = '/configuration/v1';
export const AGGREGATOR_URL = '/gateway/api/xpsearch-aggregator';
const options = {
  path: CONFIG_API_URL,
  requestInit: {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  }
};
const noAccessState = {
  jiraSites: [],
  confluenceSites: [],
  atlasWorkspaces: []
};
const dedupeEntriesById = arr => {
  return arr.filter((initial, index, currentArray) => currentArray.findIndex(matched => matched.id === initial.id) === index);
};
const dedupeEntriesByCloudId = arr => {
  return arr.filter((initial, index, currentArray) => currentArray.findIndex(matched => matched.cloudId === initial.cloudId) === index);
};
export const parseResponse = response => {
  const groupedProducts = response.resources.reduce((acc, resource) => {
    const {
      baseUrl,
      id: ari,
      siteName
    } = resource;
    const {
      id,
      product
    } = parseSiteARI(ari);
    if (product.includes(ProductsFromARI.JIRA)) {
      acc.jiraSites && acc.jiraSites.push({
        product: Products.jira,
        avatarUrl: '',
        cloudId: id,
        siteUrl: baseUrl,
        siteName
      });
    }
    if (product === ProductsFromARI.CONFLUENCE) {
      acc.confluenceSites && acc.confluenceSites.push({
        product: Products.confluence,
        avatarUrl: '',
        cloudId: id,
        siteUrl: baseUrl,
        siteName
      });
    }
    if (product === ProductsFromARI.TOWNSQUARE) {
      acc.atlasWorkspaces && acc.atlasWorkspaces.push({
        name: siteName,
        id,
        baseUrl
      });
    }
    return acc;
  }, noAccessState);
  return {
    jiraSites: dedupeEntriesByCloudId(groupedProducts.jiraSites),
    confluenceSites: dedupeEntriesByCloudId(groupedProducts.confluenceSites),
    atlasWorkspaces: dedupeEntriesById(groupedProducts.atlasWorkspaces)
  };
};
export const useSearchConfigClient = props => {
  const {
    aggregatorUrl = `${AGGREGATOR_URL}`,
    skip = false
  } = props;
  const [accessibleProducts, setAccessibleProducts] = useState(null);
  useEffect(() => {
    if (!skip && accessibleProducts === null) {
      utils.requestService({
        url: aggregatorUrl
      }, options).then(resp => {
        setAccessibleProducts(parseResponse(resp));
      }).catch(_e => {
        setAccessibleProducts(noAccessState);
      });
    }
  }, [accessibleProducts, setAccessibleProducts, aggregatorUrl, skip]);
  return accessibleProducts;
};